import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { ICellPhoneLookupResult } from './types';

export const useCellPhoneLookupMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Error) => void;
	onSuccess?: (data: ICellPhoneLookupResult, variables: string) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (contactId: string) => {
			return userSession.webServiceHelper.callAsync<ICellPhoneLookupResult>(
				`aida/cellphonelookup/${contactId}`,
				'POST'
			);
		},
		onError,
		onSuccess,
	});
};
